module.exports = __webpack_public_path__ + "img/sw2-b5.5279494c.jpg";